<template>
    <div>
        <functional-modal
            :showModal="showModal"
            :title="'Add fee for order'"
            @close="closeForm"
            @save="saveButton"
            :big="false"
            :showClose="true"
            :showSave="true"
            closeText="UI.cancel"
            saveText="UI.add"
            >
             <div :class="['col-12']" slot="body">
                <fee v-if="showModal" :editFee="editFee" @setFee="setFee"
                    @updateFee="updateFee" @deleteFee="deleteFee" @addFunctionToSave="addFunctionToSave"
                    :fractionalDigits="fractionalDigits"
                    :decimalSeparator="decimalSeparator"
                    :separator="separator"
                    :symbol="symbol"
                    @showInformationUpdateCubes="$emit('showInformationUpdateCubes')" />
             </div>
        </functional-modal>
    </div>
</template>

<script>
import Fee from './Fee.vue';
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
    name: 'fee-view',
    components: {
        Fee,
        FunctionalModal
    },
    data(){
        return {
            funcStack: {},
            decimalSeparator: '.',
            separator: ',',
            symbol: 'EUR',
            fractionalDigits: 2
        }
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        editFee: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters({
            getFees: 'getFees',
        })
    },
    methods: {
        ...mapGetters([ 'currentShop']),
        ...mapActions([
            'GetShopById'
        ]),
        closeForm() {
            this.$emit('closeFeeModal');
            this.funcStack = {}
        },
        setFee(feeData) {
            this.$emit('setFee', feeData);
        },
        updateFee(feeData) {
            this.$emit('updateFee', feeData);
        },
        deleteFee(feeId) {
            this.$emit('deleteFee', feeId)
        },
        saveFunctions(){
            Object.values(this.funcStack).forEach(async (fnc) => {
                try {
                    await fnc();
                } catch (error) {
                    throw error;
                }
            })
            this.funcStack = {}
            return Promise.resolve()
        },
        saveButton(){
            this.saveFunctions()
            .then(() => {
                this.$emit('showInformationUpdateCubes')
                this.closeForm()
            })
            .catch(err => {
                this.closeForm()
            })
        },
        addFunctionToSave(func) {
            this.funcStack[func.id] = func.run;
        },
    },
    async created () {
        let context = this.$route.params.id;

        if(!this.currentShop.currency){
            const shop = await this.GetShopById(context);
            const numberFormat = new Intl.NumberFormat('en', { style: 'currency', currency: shop?.currency?.code || "EUR" }).formatToParts(10000.10);
            this.symbol = numberFormat.find(x => x.type === 'currency').value;
            this.decimalSeparator = numberFormat.find(x => x.type === 'decimal').value;
            this.separator = numberFormat.find(x => x.type === 'group').value;
            this.fractionalDigits = shop?.currency?.fractionDigits || 2;
        }
    }
}
</script>
